import LinkTemplate from '../../html/components/link.html'

import Component from '../shared/component'

export const LinkMixin = {
  props: {
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    }
  }
}

export const Link = Component('v-link', {
  mixins: [
    LinkMixin
  ],
  template: LinkTemplate,
  computed: {
    rel () {
      if (this.target === '_blank') {
        return 'noopener noreferrer'
      }
    }
  }
})
